<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<p-dialog [(visible)]="dialogFormVisible"
          [header]="'page.' + this.transPartKey + '.dialog_title' | translate"
          [modal]="true" [styleClass]="'p-fluid recap-list-dialog'"
          [closeOnEscape]="true"
          (visibleChange)="this.dialogFormVisibleChange.emit(this.dialogFormVisible)"
          (onShow)="showDialog()"
          appendTo="body" position="top"
          [resizable]="false">
  <!--          (visibleChange)="dialogFormVisibleChange.emit(dialogFormVisible)"-->
  <ng-template pTemplate="content">
    <app-archive-recap-list [(loading)]="loading"
                            [(selectedRecords)]="selectedRecords"
                            [(differential)]="differential"></app-archive-recap-list>

  </ng-template>
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="closeDialog()"
            [label]="'common.dialog.cancel' | translate"
            class="p-button-warning p-button-sm"></button>
    <button pButton type="button" (click)="submit()" [disabled]="loading||selectedRecords.length==0"
            [label]="'common.dialog.execute' | translate"
            class="p-button-success p-button-sm"></button>
  </ng-template>
</p-dialog>
